import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { TopicRequestModel } from '../../../models/feedback.model';
import { AlertService } from '../../../services/alert.service';
import { ContactService } from '../../../services/contact.service';
import { UserService } from '../../../services/user.service';
import { CaptchaComponent } from '../captcha/captcha.component';

@Component({
  selector: 'app-topic-request',
  templateUrl: './topic-request.component.html',
  styleUrl: './topic-request.component.scss',
  standalone: false,
})
export class TopicRequestComponent {
  public isLoading = false;
  constructor(
    private contactService: ContactService,
    private alertService: AlertService,
    public userService: UserService,
    private dialogService: DialogService
  ) {
    this.topicRequestForm
      .get('name')
      .setValue(this.userService.currentUser$.value?.firstname);
    this.topicRequestForm
      .get('email')
      .setValue(this.userService.currentUser$.value?.email);
    if (!this.userService.currentUser$.value) {
      this.topicRequestForm
        .get('privacyConfirmation')
        .setValidators([Validators.requiredTrue]);
      this.topicRequestForm.get('privacyConfirmation').updateValueAndValidity();
    }
  }

  public topicRequestForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    topic: new FormControl('', [Validators.required]),
    privacyConfirmation: new FormControl(false),
  });

  public submit(): void {
    if (this.topicRequestForm.invalid) {
      this.topicRequestForm.markAllAsTouched();
      this.alertService.showErrorAlert('Bitte fülle alle Felder aus.');
      return;
    }
    const topicRequest: TopicRequestModel = {
      name: this.topicRequestForm.get('name').value,
      email: this.topicRequestForm.get('email').value,
      topic: this.topicRequestForm.get('topic').value,
    };

    const dialogRef = this.dialogService.open(CaptchaComponent, {
      header: 'Captcha',
      width: '450px',
      breakpoints: {
        '768px': '90vw',
      },
    });
    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.sendTopicRequest(topicRequest);
      }
    });
  }

  private sendTopicRequest(topicRequest: TopicRequestModel): void {
    this.isLoading = true;
    this.contactService.sendTopicRequestMail(topicRequest).subscribe({
      next: () => {
        this.topicRequestForm.get('topic').reset();
        this.alertService.showSuccessAlert(
          'Dein Themenwunsch wurde erfolgreich eingereicht.'
        );
        this.isLoading = false;
      },
      error: () => {
        this.alertService.showErrorAlert(
          'Der Themenwunsch konnte leider nicht gesendet werden. Bitte versuche es später erneut.'
        );
        this.isLoading = false;
      },
    });
  }
}
